import { FunctionComponent } from 'react';
import { Typography } from './../../../tailwindcomponents';

type TopRowProps = {
  tabValue: number,
  staticTabValue: number,
  text: string
}

const TopRow: FunctionComponent<TopRowProps> = ({ tabValue, staticTabValue, text }) => {
  return (
    <div className={tabValue === staticTabValue ?
      `${tabValue === 0 ? "bg-accent-blue" : "bg-status-actv"} py-2 border border-black rounded-[16px] mx-2 text-white`
      :
      "py-2 border border-black rounded-[16px] mx-2 text-white"}>
      <Typography color='textPrimary' textColor={tabValue === staticTabValue ? 'white' : undefined} align='center' variant='h1' text={text} />
    </div>
  );
};
export default TopRow;